"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementToHtml = void 0;
var _plateCommon = require("@udecode/plate-common");
var _htmlEntities = require("html-entities");
var _createElementWithSlate = require("./utils/createElementWithSlate");
var _renderToStaticMarkupClient = require("./utils/renderToStaticMarkupClient");
var _stripClassNames = require("./utils/stripClassNames");
var elementToHtml = function elementToHtml(editor, _ref) {
  var dndWrapper = _ref.dndWrapper,
    plateProps = _ref.plateProps,
    preserveClassNames = _ref.preserveClassNames,
    props = _ref.props;
  var html = "<div>".concat(props.children, "</div>");

  // If no type provided we wrap children with div tag
  if (!props.element.type) {
    return html;
  }
  props = (0, _plateCommon.pipeInjectProps)(editor, props);

  // Search for matching plugin based on element type
  editor.plugins.some(function (plugin) {
    var _renderToStaticMarkup, _plugin$serializeHtml, _plugin$serializeHtml2;
    if (!plugin.isElement || plugin.serializeHtml === null || props.element.type !== plugin.type) return false;

    // Render element using picked plugins renderElement function and ReactDOM
    html = (0, _htmlEntities.decode)((_renderToStaticMarkup = (0, _renderToStaticMarkupClient.renderToStaticMarkup)((0, _createElementWithSlate.createElementWithSlate)(_objectSpread({}, plateProps, {
      children: (_plugin$serializeHtml = (_plugin$serializeHtml2 = plugin.serializeHtml) === null || _plugin$serializeHtml2 === void 0 ? void 0 : _plugin$serializeHtml2.call(plugin, props)) !== null && _plugin$serializeHtml !== void 0 ? _plugin$serializeHtml : (0, _plateCommon.pluginRenderElement)(editor, plugin)(props)
    }), dndWrapper))) !== null && _renderToStaticMarkup !== void 0 ? _renderToStaticMarkup : '');
    html = (0, _stripClassNames.stripClassNames)(html, {
      preserveClassNames: preserveClassNames
    });
    return true;
  });
  return html;
};
exports.elementToHtml = elementToHtml;